module.exports = __webpack_public_path__ + "img/CleanMob.4efaea95.png";